import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import { useGeneralPolicies } from "../hooks/useGeneralPolicies";
import { useOrganizationPolicies } from "../hooks/useOrganizationPolicies";
import { useAppContext } from "../hooks/useAppContext";

const MainSideMenu = () => {
  const { currentOrganization } = useAppContext();
  const { authorizedSystemAdmin } = useGeneralPolicies();
  const {
    authorizedToManageOrgUsers,
    authorizedToManageProjects,
    authorizedToManageGangMembers,
    authorizedToManageLicences,
    authorizedToManageReferenceProcedures,
    authorizedToManageConfiguration,
    authorizedToManageDocumentTypes,
    authorizedToManageOrgRoles,
    authorizedToManageAdminRoles,
    authorizedToManagePermitTypes,
    authorizedToViewOrganizationDashboard,
  } = useOrganizationPolicies();

  const orgName = currentOrganization?.name;

  return (
    <Menu borderless secondary vertical color="black" style={{ "margin-right": "1px" }} size="large">
      {currentOrganization && <Menu.Item icon="home" as={NavLink} content="Home" to={"/" + orgName + "/home"} />}
      {currentOrganization && authorizedToViewOrganizationDashboard && (
        <Menu.Item icon="chart line" as={NavLink} content="Dashboard" to={"/" + orgName + "/metrics-dashboard"} />
      )}
      {authorizedToManageProjects && (
        <Menu.Item icon="tasks" as={NavLink} content="Projects" to={"/" + orgName + "/projects"} />
      )}
      {authorizedToManageOrgUsers && (
        <Menu.Item icon="users" as={NavLink} content="Users" to={"/" + orgName + "/users"} />
      )}
      {authorizedToManageLicences && (
        <Menu.Item icon="key" as={NavLink} content="Licences" to={"/" + orgName + "/licences"} />
      )}
      {authorizedToManageGangMembers && (
        <Menu.Item icon="id card" as={NavLink} content="Gang members" to={"/" + orgName + "/gang-members"} />
      )}
      {authorizedToManageReferenceProcedures && (
        <Menu.Item
          icon="file"
          as={NavLink}
          content="Reference Procedures"
          to={"/" + orgName + "/reference-procedures"}
        />
      )}
      {(authorizedToManagePermitTypes ||
        authorizedToManageConfiguration ||
        authorizedToManageDocumentTypes ||
        authorizedToManageOrgRoles ||
        authorizedToManageAdminRoles) && (
        <Menu.Item
          icon="settings"
          as={NavLink}
          content="Settings"
          to={
            "/" +
            orgName +
            "/settings/" +
            (authorizedToManagePermitTypes
              ? "permit-types"
              : authorizedToManageDocumentTypes
                ? "document-types"
                : authorizedToManageOrgRoles
                  ? "roles"
                  : authorizedToManageAdminRoles
                    ? "admin-roles"
                    : "configurations")
          }
        />
      )}
      {authorizedSystemAdmin && <Menu.Item as={NavLink} content="Admin Settings" to="/settings/organizations" />}
    </Menu>
  );
};

export default MainSideMenu;
